import React from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription
} from "src/components";

const GroupAdminSelectionModal = (props) => {
    const { onClose, onDelete, onSelect, open } = props;

    const handleDelete = () => {
        onClose();
        onDelete();
    };

    return (
        <StandardModal
            open={open}
            onClose={onClose}
            title="Leave Group"
            widthMode="small"
            footer={(
                <StandardModalActionGroup $center>
                    <StandardModalActionButton $variant="danger" onClick={handleDelete}>
                        Delete
                    </StandardModalActionButton>
                    <StandardModalActionButton $variant="primary" onClick={onSelect}>
                        Choose Admin
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalDescription>
               Please choose a new admin from the current members to keep the chat going after you`ve left, or you can delete the chat entirely.
            </StandardModalDescription>
        </StandardModal>
    );
};

export default GroupAdminSelectionModal;